import React from "react";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { Grid } from "@client/shared/components";
import Paper from "@mui/material/Paper";

import style from "./style";
import { globalStyles, noop } from "@client/shared/constants";
import CreateBroadcast from "./create-broadcast";
import WarningDialog from "./warning";

const DashboardView = ({
  entries = [],
  entriesCount = 0,
  isFetching = false,
  columnConfig = [],
  pageSize = 5,
  pageNumber = 1,
  order = null,
  orderBy = "",
  isFormOpen = false,
  voicemailList = [],
  siteList = [],
  departmentList = [],
  userRoleList = [],
  individualContactList = [],
  extensionList = [],
  phoneNumberList = [],
  countryList = [],
  accountInfo = {},
  selectedRows = [],
  areAllSelected = false,
  isDeleting = false,
  deletingIds = null,
  rowBeingEdited = null,
  showDetails = false,
  roleAccess = {},
  handlePageNumberChange = noop,
  handlePageSizeChange = noop,
  handleSortChange = noop,
  handleSelectionChange = noop,
  handleSelectAll = noop,
  handleGridReady = noop,
  handleFormOpen = noop,
  handleDelete = noop,
  handleDeleteClose = noop,
  setState = noop,
  userData = {},
  handleJwksResponse = noop,
}) => {
  return (
    <>
      <Box
        sx={{
          p: 2,
        }}
      >
        <Paper
          elevation={0}
          sx={{
            p: 3,
            ...style.pageTitleWrapper,
          }}
        >
          <Box
            sx={{
              ...globalStyles.display.flex,
              ...globalStyles.flex.justify.between,
            }}
          >
            <Box>
              <Typography variant="h6">Voicemail Broadcast</Typography>
              <Typography
                variant="body2"
                sx={{
                  ...globalStyles.text.color.secondaryText,
                }}
              >
                Customize and distribute bulk voicemail broadcasts.
              </Typography>
            </Box>
            {roleAccess.sendBroadcasts && (
              <Box>
                {((!!selectedRows.length || areAllSelected) && !!entries.length) && (
                  <Button
                    color="error"
                    variant="outlined"
                    onClick={() => {
                      if (userData.deletePreference) {
                        handleDelete(selectedRows);
                      } else {
                        setState((prevState) => ({
                          ...prevState,
                          deletingIds: areAllSelected ? "ALL" : selectedRows,
                        }));
                      }
                    }}
                    sx={{
                      mr: 2,
                    }}
                  >
                    Delete
                  </Button>
                )}
                <Button
                  variant="contained"
                  onClick={() => handleFormOpen(true)}
                >
                  Create Broadcast
                </Button>
              </Box>
            )}
          </Box>
        </Paper>
        <Paper
          elevation={0}
          sx={{
            mt: 2,
            ...style.tablePaper,
          }}
        >
          <Grid
            hasSelection
            hasPagination
            rows={entries}
            totalRows={entriesCount}
            isLoading={isFetching}
            columns={columnConfig}
            pageSize={pageSize}
            pageNumber={pageNumber}
            order={order}
            orderBy={orderBy}
            onPageNumberChange={handlePageNumberChange}
            onPageSizeChange={handlePageSizeChange}
            onSortChange={handleSortChange}
            onSelectionChange={handleSelectionChange}
            onSelectAll={handleSelectAll}
            onReady={handleGridReady}
            classes={{
              container: style.tablePaper,
            }}
            entriesText="Broadcasts"
          />
        </Paper>
      </Box>
      {isFormOpen && (
        <CreateBroadcast
          rowBeingEdited={rowBeingEdited}
          showDetails={showDetails}
          voicemailList={voicemailList}
          siteList={siteList}
          departmentList={departmentList}
          userRoleList={userRoleList}
          individualContactList={individualContactList}
          extensionList={extensionList}
          phoneNumberList={phoneNumberList}
          countryList={countryList}
          accountInfo={accountInfo}
          roleAccess={roleAccess}
          onClose={(isSubmitted = false) => {
            handleFormOpen(false, isSubmitted);
          }}
          handleDelete={handleDelete}
          handleJwksResponse={handleJwksResponse}
        />
      )}
      {deletingIds && !userData.deletePreference && (
        <WarningDialog
          isOpen={!userData.deletePreference}
          onClose={handleDeleteClose}
          content={`Deleting ${
            deletingIds.length > 1 || deletingIds === "ALL" ? "these" : "this"
          } ${
            deletingIds.length > 1 || deletingIds === "ALL"
              ? "broadcasts"
              : "broadcast"
          } will remove all  ${
            deletingIds.length > 1 || deletingIds === "ALL" ? "their" : "it's"
          } information and audio files from your account.`}
          handleDelete={() => handleDelete(deletingIds)}
          isButtonLoading={isDeleting}
          userData={userData}
          userPreference={userData.deletePreference}
          preferenceName="deletePreference"
        />
      )}
    </>
  );
};

export default DashboardView;
